import React from "react";
import { Modal, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import Util from "../../../../util/Util";
import {
  createGroup,
  updateGroup,
} from "../../../../actions/clients/groups/groups";
import { checkIfCompanyUrlExists } from "../../../../actions/clients/company/company";

class GroupAddModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: undefined,
      url: undefined,
      nameError: null,
      urlError: null,
    };
    if (this.props.group !== undefined) {
      this.state = {
        name: this.props.group.name,
        url: this.props.group.url,
      };
    }
  }

  handleSubmit() {
    if (this.hasError()) return;

    let data = {
      name: this.state.name,
      url: this.state.url,
    };

    if (this.props.group) {
      data._id = this.props.group._id;

      return this.props.onGroupEdit(
        data,
        () => this.props.close(),
        (e) => console.log(e),
      );
    }

    this.props.onGroupCreate(
      data,
      () => this.props.close(),
      (e) => console.log(e),
    );
  }

  hasEmptyField() {
    return !this.state.name || !this.state.url;
  }

  hasError() {
    return this.state.urlError || this.state.nameError;
  }

  onChange(field, value) {
    this.setState({ [field]: value });

    // Check if name is not empty
    if (field === "name" && !Util.emptyString(value)) {
      this.setState({ nameError: null });
      // Check if name < 50
      if (value.length > 50) {
        this.setState({
          nameError: <FormattedMessage id="Character.Max" />,
        });
      }
      // Check name regex
      const regex = /[A-Z.\s0-9]/g;
      const found = value.match(regex);
      if (
        (found === null && value.length !== 0) ||
        found.length < value.length
      ) {
        this.setState({
          nameError: <FormattedMessage id="Character.Type" />,
        });
      }
    }

    // Check if url is not empty and not already taken
    if (field === "url" && !Util.emptyString(value)) {
      this.props.onCheckIfUrlExists(
        value,
        () => {
          this.setState({
            urlError: <FormattedMessage id="URL.Already.Taken" />,
          });
        },
        () => this.setState({ urlError: null }),
      );

      if (value.length > 20) {
        this.setState({
          urlError: <FormattedMessage id="Character.Max" />,
        });
      }
      // Check company_name regex
      const regex = /[a-z0-9]/g;
      const found = value.match(regex);
      if (
        (found === null && value.length !== 0) ||
        found.length < value.length
      ) {
        this.setState({
          urlError: <FormattedMessage id="Character.Type.AlphaNum" />,
        });
      }
    }
  }

  render() {
    return (
      <Modal
        show={true}
        size="lg"
        onHide={() => this.props.close()}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {this.props.group === undefined ? (
              <FormattedMessage id="Group.Add" />
            ) : (
              <FormattedMessage id="Group.Update" />
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form autoComplete="off">
            <div className="form-group row">
              <label htmlFor="date" className="col-5 col-form-label">
                <FormattedMessage id="Name" />
              </label>
              <div className="col-7">
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-control"
                  defaultValue={this.state.name}
                  onInput={(e) =>
                    (e.target.value = ("" + e.target.value).toUpperCase())
                  }
                  onChange={(e) => this.onChange("name", "" + e.target.value)}
                />
                <small className="text-danger">{this.state.nameError}</small>
              </div>
            </div>

            <div className="form-group row">
              <label htmlFor="date" className="col-5 col-form-label">
                <FormattedMessage id="URL.Login" />
              </label>
              <div className="col-7">
                <input
                  type="text"
                  id="url"
                  name="url"
                  defaultValue={this.state.url}
                  onInput={(e) =>
                    (e.target.value = ("" + e.target.value).toLowerCase())
                  }
                  className="form-control"
                  onChange={(e) => this.onChange("url", e.target.value)}
                />
                <small className="text-danger">{this.state.urlError}</small>
              </div>
            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => this.props.close()}>
            <FormattedMessage id="Cancel" />
          </Button>
          <Button variant="info" onClick={() => this.handleSubmit()}>
            <FormattedMessage id={this.props.group ? "Edit" : "Add"} />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCheckIfUrlExists: (url, existsCallback, noExistsCallback) =>
      checkIfCompanyUrlExists(url, existsCallback, noExistsCallback),
    onGroupCreate: (data, successCallback, failureCallback) =>
      dispatch(createGroup(data, successCallback, failureCallback)),
    onGroupEdit: (data, successCallback, failureCallback) =>
      dispatch(updateGroup(data, successCallback, failureCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(GroupAddModal));
